import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

function PlayerStatsSMPTwoYear() {
  return (
    <Box sx={{ flexGrow: 1, py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            26K Days Permanent Survival SMP Stats Two Year
          </Typography>

          <Box
            component="iframe"
            src="https://www.mcverse.city/stats-two-year/index.html#hof"
            sx={{
              width: "100%",
              height: "70vh",
              border: "none",
              borderRadius: "4px",
              mt: 2,
              mb: 2,
              boxShadow: 2,
            }}
            title="MCVerse SMP Stats Two Year"
            allowFullScreen
          />
        </Paper>
      </Container>
    </Box>
  );
}

export default PlayerStatsSMPTwoYear;
